import { ChevronDown } from 'lucide-react';
import { CustomPricingCardProps } from '../../types/pricing.types';
import { PlanPurchaseButton } from './plan-purchase-button';
import { PlanPrice } from './plan-price';
import { PlanFeatures } from './plan-features';
import { ProxyAddon } from './proxy-addon';

export const CustomPricingCard = ({
  plans,
  selectedPlanId,
  onChangePlan,
  price,
  priceForYear,
  finalPrice,
  period,
  isUserPlan,
  isUserAuthorized,
  isDowngradeDisabled = false,
  addonPricePerGb,
  proxyTrafficGb,
  onProxyTrafficChange,
  buttonText,
  onSelect,
}: CustomPricingCardProps) => {
  const selectedPlan = plans.find((p) => p.id === selectedPlanId) ?? plans[0];
  const features = selectedPlan?.features ?? [];
  const isButtonDisabled = isUserPlan || isDowngradeDisabled || !isUserAuthorized;
  const shouldShowAddons = !isUserPlan && !isDowngradeDisabled && isUserAuthorized;

  return (
    <article className='relative flex flex-col rounded-2xl border border-ob-border bg-ob-raised p-[30px] xl:min-h-[548px]'>
      <h2 className='mb-[26px] text-[28px] font-semibold leading-none text-ob-text'>Custom</h2>
      <div className='relative -mt-1.5 mb-[26px]'>
        <select
          value={selectedPlanId}
          onChange={(e) => onChangePlan(e.target.value)}
          aria-label='Active profiles'
          className='h-[46px] w-full cursor-pointer appearance-none rounded-[10px] border border-ob-border bg-ob-canvas pl-3.5 pr-12 text-ob-text-secondary outline-none focus:border-ob-primary'
        >
          {plans.map((plan) => (
            <option key={plan.id} value={plan.id}>
              {plan.profiles.toLocaleString()} active profiles
            </option>
          ))}
        </select>
        <ChevronDown
          className='pointer-events-none absolute right-[18px] top-1/2 h-4 w-4 -translate-y-1/2 text-ob-focus'
          strokeWidth={1.5}
          aria-hidden
        />
      </div>

      <PlanPrice price={price} finalPrice={finalPrice} priceForYear={priceForYear} period={period} />
      <PlanFeatures features={features} />

      <div className='mt-auto'>
        {shouldShowAddons && (
          <ProxyAddon
            inputId='proxy-traffic-custom'
            period={period}
            addonPricePerGb={addonPricePerGb}
            proxyTrafficGb={proxyTrafficGb}
            onProxyTrafficChange={onProxyTrafficChange}
          />
        )}
        <div className='mt-6'>
          <PlanPurchaseButton
            label={isUserPlan ? 'Current Active Plan' : buttonText}
            variant='outline'
            isDisabled={isButtonDisabled}
            showDowngradeTooltip={isDowngradeDisabled && !isUserPlan}
            onSelect={onSelect}
          />
        </div>
      </div>
    </article>
  );
};
